import { Grid } from '@material-ui/core'
import { rgba } from 'polished'
import styled from 'styled-components'
import { css } from 'styled-components'

export const Wrapper = styled.div`
  padding-bottom: 24px;
`

type TitleProps = {
  completed?: boolean
}

export const Title = styled.div<TitleProps>`
  ${({ theme, completed }) => css`
    display: flex;
    align-items: center;
    gap: 4px;

    .step {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      font-size: ${theme.ds.typography.size.xxsmall};
      font-weight: ${theme.ds.typography.weight.semiBold};
      color: ${theme.ds.colors.white};
      background-color: ${completed
        ? theme.ds.colors.primary600
        : theme.ds.colors.neutral300};
    }

    .c-title {
      color: ${theme.ds.colors.textPrimary};
      font-weight: ${theme.ds.typography.weight.semiBold};
      font-size: ${theme.ds.typography.size.xsmall};
      line-height: ${theme.ds.typography.lineHeight.medium};
    }
  `}
`

export const SpacingLine = styled.div`
  border-left: 1px solid ${({ theme }) => theme.ds.colors.neutral300};
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 9px;
  height: 16px;
`

export const CardInfo = styled.div`
  margin: 16px 0 0;
  padding-top: 8px;
  border-top: 2px solid ${({ theme }) => theme.ds.colors.neutral50};

  .c-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    > ${Title} {
      /* border: 2px solid blue; */
    }

    > .btn-edit {
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .c-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
    /* border: 1px solid blue; */
  }

  .item-wrapper {
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    color: ${({ theme }) => theme.ds.colors.neutral500};
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
  }

  .item-result {
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.neutral900};
    font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
  }

  .calendar-container {
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      width: 16px;
    }
  }
`

export const BoxInfo = styled.div`
  /* border: 1px solid red; */

  .box-header {
    padding: 4px 12px;
    background-color: ${({ theme }) => theme.ds.colors.neutral50};

    .box-title {
      font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
      color: ${({ theme }) => theme.ds.colors.textSecondary};
      font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
      line-height: 16px;
    }
  }

  .box-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 4px;

    &.-spacing {
      gap: 8px;
    }
  }

  .text {
    color: ${({ theme }) => theme.ds.colors.textPrimary};
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
    font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
    line-height: 16px;

    b {
      font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
      font-family: ${({ theme }) => theme.ds.typography.fontFamily};
    }
  }

  .label {
    font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
    font-size: ${({ theme }) => theme.ds.typography.size.xxxsmall};
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    line-height: 16px;
  }

  .text-box {
    padding: 4px 8px;
    background-color: ${({ theme }) => theme.ds.colors.neutral50};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.ds.colors.neutral100};

    .desc {
      font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
      color: ${({ theme }) => theme.ds.colors.textPrimary};
      font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
      line-height: 16px;
    }

    &.-warning {
      padding: 8px;
      background-color: ${({ theme }) =>
        rgba(theme.ds.colors.attention200, 0.4)};
      border: 1px solid ${({ theme }) => theme.ds.colors.attention400};

      .desc {
        font-size: ${({ theme }) => theme.ds.typography.size.xxxsmall};
        color: ${({ theme }) => theme.ds.colors.warning700};
        font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
        line-height: 1.4;
      }
    }
  }
`

export const TableContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.ds.colors.neutral100};
  overflow: hidden;
  /* margin-top: 4px; */
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  th,
  td {
    padding: 8px 12px;
    line-height: 16px;
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
  }

  th {
    font-weight: ${({ theme }) => theme.ds.typography.weight.normal};
    color: ${({ theme }) => theme.ds.colors.textPrimary};
    font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
  }

  td {
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    font-family: ${({ theme }) => theme.ds.typography.fontFamily};
    color: ${({ theme }) => theme.ds.colors.textPrimary};
    padding: 4px 12px;
  }

  .group-header-row {
    background-color: ${({ theme }) => theme.ds.colors.neutral50};
  }

  .group-header {
    padding: 4px 12px;
    font-size: ${({ theme }) => theme.ds.typography.size.xxxsmall};
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    color: ${({ theme }) => theme.ds.colors.textSecondary};
    font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
  }

  .col-code {
    width: 60px;
  }

  .col-quant {
    width: 40px;
  }

  .justification-row {
    padding: 0.5rem 0.75rem;

    .label {
      font-family: ${({ theme }) => theme.ds.typography.fontFamilySecondary};
      font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
      font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
      color: ${({ theme }) => theme.ds.colors.textSecondary};
      line-height: 16px;
    }

    .text-box {
      margin-top: 0.25rem;
      padding: 0.25rem 0.5rem;
      background-color: ${({ theme }) => theme.ds.colors.neutral50};
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.ds.colors.neutral100};

      .desc {
        font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        color: ${({ theme }) => theme.ds.colors.textPrimary};
        font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
        line-height: 16px;
      }
    }
  }
`

export const StyledGridItem = styled(Grid)`
  /* margin-bottom: 4px; */
  margin: 0;
  @media (max-width: 959px) {
    margin-top: -4px;
  }
`

export const CardHospitalizedInfo = styled.div`
  padding: 8px;
  background-color: ${({ theme }) => theme.ds.colors.infoBackground};
  border: 1px solid ${({ theme }) => rgba(theme.ds.colors.infoBorder, 0.3)};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const LowAcceptanceTag = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: 0.25rem;
  margin-left: 0.25rem;

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    path {
      fill: ${({ theme }) => theme.ds.colors.danger700};
    }
  }

  > span {
    line-height: 12px;
  }
`

export const StepEmptyState = styled.div`
  > ${Title} {
    /* border: 1px solid red; */
  }

  > ${SpacingLine} {
    /* border: 1px solid red; */
  }
`
